import { tv, type VariantProps } from 'tailwind-variants';
export type MlCtaCardVariants = VariantProps<typeof mlCtaCard>;

const mlCtaCard = tv({
  base: 'relative shadow-card flex flex-col justify-end rounded-30 overflow-hidden',
  slots: {
    body: 'z-10 flex flex-col gap-6',
  },
  variants: {
    size: {
      sm: {
        base: 'lg:min-h-374 pr-72 pl-7.5 pb-7.5 pt-13',
        body: '',
      },
      lg: {
        base: 'lg:min-h-775 px-10 py-15 lg:p-15 ',
        body: '',
      },
    },
    showCta: {
      true: '',
    },
  },
  compoundVariants: [
    {
      size: 'lg',
      showCta: true,
      className: {
        body: 'pb-10',
      },
    },
  ],
});

export default mlCtaCard;
